import { useEffect, useCallback, useRef } from 'react';
import { useSocketContext } from '../providers/SocketProvider';

export function useSocket<T>(event: string, handler: (data: T) => void) {
  const { socket } = useSocketContext();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  const stableHandler = useCallback((data: T) => {
    handlerRef.current(data);
  }, []);

  useEffect(() => {
    if (!socket) return;
    socket.on(event, stableHandler);
    return () => {
      socket.off(event, stableHandler);
    };
  }, [socket, event, stableHandler]);
}
